/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const { setCustomer, clear } = createActions(
	{
    SET_CUSTOMER: (customerName) => ({ customer: customerName }),
		CLEAR: () => ({})
	},
	{ prefix: ROOT_SLICE }
);

export { setCustomer, clear };
